import { ModelConstants } from '../model-constants';
import { IModel } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { AzureKeyVault } from './key-vault';
import { format } from '../../shared/utils/string.util';
import { validateAKVLinkedServiceReference } from '../../shared/utils/linkedservice-validation-util';

@Metamodel.model({
    name: ModelConstants.hdfsLinkedService,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Hdfs_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Hdfs_DisplayText)
    ]
})
export class HdfsLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    @Metamodel.attribute({
        display: stringResources.ModelName_HdfsClusterUri
    })
    public url?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public userName?: string;
    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedServiceReference
        }
    })
    public password?: string | AzureKeyVault; // TODO: need a secure type to make sure this won't be exposed to customer.

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
